import React from "react";
import type { FC, PropsWithChildren } from "react";

import { Media } from "../../../Media";
import { createDisplayNameForUniCardElement } from "../../utils/getDisplayName";
import { createTestIdForUniCardElement } from "../../utils/getTestId";

import type { AspectRatioType } from "../../../Media/types";

const UNI_CARD_MEDIA_TEST_ID = createTestIdForUniCardElement("media");

interface IUniCardMediaProps extends PropsWithChildren {
    aspectRatio?: AspectRatioType;
    "data-tsid"?: string;
}

const defaultProps: IUniCardMediaProps = {
    aspectRatio: {
        height: 1,
        width: 1,
    },
    "data-tsid": UNI_CARD_MEDIA_TEST_ID,
};

export const UniCardMedia: FC<IUniCardMediaProps> = (_props) => {
    const props: IUniCardMediaProps = {
        ...defaultProps,
        ..._props,
    };
    return (
        <Media
            aspectRatio={props.aspectRatio}
            roundCorners
            data-tsid={props["data-tsid"]}
        >
            {props.children}
        </Media>
    );
};

UniCardMedia.displayName = createDisplayNameForUniCardElement("Media");

export default UniCardMedia;
